module.exports = __webpack_public_path__ + "media/images/lilica/lilica5-6283a227d27eeba08fe998c98303c1d5.png";